import { getKbConfig } from "@/features/branding";
import { Tool } from "@/types/tools";
import PushpinOutlined from "@ant-design/icons/es/icons/PushpinOutlined";
import { useRouter } from "next/router";
import { useEffect } from "react";
const buildSidebarRedirect = (): string => {
  return getKbConfig().geocoding.publicDocsUrl || "/geocoding";
};
const Render = () => {
  const router = useRouter();
  useEffect(() => {
    if (!getKbConfig().geocoding.embedPostId) {
      router.replace(buildSidebarRedirect());
    }
  }, []);
  return <></>;
};
export default {
  id: "geocoding",
  category: "reference",
  keyPrefix: "reference.geocoding",
  icon: <PushpinOutlined />,
  render: () => <Render />,
  buildSidebarRedirect
} as Tool;